/* eslint-disable no-new */
import * as types from './mutation-define'
import axios from 'axios';
import msgpad_show from "../msgpad_show"

import * as API from "@/api/module/vip"

import Vue from 'vue'


const state = {
  vip: {
    mobile: "",
    name: "",
    user_group:"",
    // addr_act:"",
    // history_addr:[],
    // child:{birthday:"",sex:true},
    // history_addr:[],
    // spec_info: { userid: "" },
    user_amount: 0,
  },
  saved: []
}

/*
vip: {
    mobile: "",
    // name: "张明亮",
    user_group:"",
    // addr_act:"",
    // history_addr:[],
    // child:{birthday:"",sex:true},
    // history_addr:[],
    // spec_info: { userid: "" },
    // user_amount: 120,
  },
*/
// getters
const getters = {
	vip_info         : state => state.vip,
	vip_prepay_money : state => state.vip.prepay_money,
	// vip_amount_less  : state => state.vip.amount_less,
	vip_saved        : state => state.saved,
}


// actions
const actions = {
	act_lookup_vip(context, { mobile, callback }) {
		return API.lookup_vip(mobile).then(resp => {
			if (resp.status == 200) {
				let vip_type = "";
				if (resp.data['vip']){
					// debugger
					vip_type = resp.data['vip'].user_group?resp.data['vip'].user_group:'';

					context.commit(types.VIP_SET_VIP_INFO, resp.data['vip']);
				}else{
					msgpad_show("msgpad", "失败", "没有此会员信息", 'error')
					context.commit(types.VIP_SET_VIP_INFO, {mobile:"",user_group:""});
					context.commit(types.PRODUCTS_PREPARE_LIST, []);
				}

				context.commit(types.PRODUCTS_RESET_VIP_PRICE, vip_type);


				// if(resp.data['saved']){
				// 	context.commit(types.VIP_SET_VIP_SAVED, resp.data['saved']);
				// 	context.commit(types.PRODUCTS_PREPARE_LIST, resp.data['saved']?resp.data['saved']:[]);
				// }else{
				// 	context.commit(types.VIP_SET_VIP_SAVED, []);
				// 	context.commit(types.PRODUCTS_PREPARE_LIST, resp.data['saved']?resp.data['saved']:[]);
				// }
				context.commit(types.VIP_SET_VIP_SAVED    , resp.data['saved']?resp.data['saved']:[]);
				context.commit(types.PRODUCTS_PREPARE_LIST, resp.data['saved']?resp.data['saved']:[]);



				if(callback) callback(resp.data)
			} else {
				msgpad_show("msgpad", "失败", resp.data.err_msg, 'error')
			}
		}).catch(function(err) {
			msgpad_show("msgpad", "NETWORK_ERROR", err.message, 'error')
		})
	},

	act_create_vip(context, {data,callback} ) {
		let vip_info = data;
		// let url = "/vip?oper=add"
		API.create_or_update_vip('add',{data:vip_info}).then(resp=>{
			if (resp.status == 200) {
				console.log("CRATE_VIP:",resp.data)
				context.commit(types.VIP_SET_VIP_INFO, resp.data);
				context.commit(types.PRODUCTS_RESET_VIP_PRICE, resp.data.user_group);
				context.commit(types.PRODUCTS_PREPARE_LIST, []);
				context.commit(types.VIP_SET_VIP_SAVED, []);
				if(callback)callback(data);
			}

		}).catch(function(err) {
			if(err.response.data.search("alreay exist")>0){
				msgpad_show("msgpad", "NETWORK_ERROR", "会员已经存在!", 'error')
			}else{
				msgpad_show("msgpad", "NETWORK_ERROR", err.message, 'error')
			}
		})
	},

	act_edit_vip(context, vip_info) {
		// let url = "/vip?oper=edit"
		API.create_or_update_vip('edit',{data:vip_info}).then(resp=>{
			if (resp.status == 200) {
				console.log("EDIT_VIP:",resp.data)
				context.commit(types.VIP_SET_VIP_INFO, resp.data);
				context.commit(types.PRODUCTS_RESET_VIP_PRICE, resp.data.user_group);

			}
		}).catch(function(err) {
			msgpad_show("msgpad", "NETWORK_ERROR", err.message, 'error');
		})
	},

	act_get_vip_saved(context, mobile) {
		// let url = "/vip?oper=saved"
		return API.lookup_vip_saved_products(mobile).then(resp=>{
			context.commit(types.VIP_SET_VIP_SAVED, resp.data);
			return resp.data;
		}).catch(function(err) {
			msgpad_show("msgpad", "NETWORK_ERROR", err.message, 'error');
		})
	}
}

// mutations
const mutations = {
  [types.VIP_SET_VIP_INFO](state, vip) {
    if(!vip.spec_info){
    	vip.spec_info = { userid: "" }
    }
    state.vip = vip;
  },

  [types.VIP_SET_VIP_SAVED](state, saved) {
  	// debugger
    state.saved = saved;
  },
  [types.VIP_PREPAY_MONEY](state,val){
  	state.vip.prepay_money = val;
  },
  [types.VIP_PREPAY_MONEY_ADJUST](state,val){
  	state.vip.prepay_money += val;
  },

  /******************************************/
  [types.VIP_AMOUNT_ADJUST](state,val){
  	state.vip.user_amount += val;
  },
  [types.USE_AMOUNT_SET](state,val){
  	state.vip.user_amount = val;
  }
}




export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/vip_store.js